import * as React from 'react';
import type { CreativeWork, WithContext } from 'schema-dts';

import type { SanityResource } from '#/lib/sanity/queries/resource';
import { blocksToText } from '#/lib/sanity/utils';

import { schemaOrganization } from './consts';
import { RenderSEOSchema } from './Render';

export function ResourceSchema({
  title,
  href,
  excerpt,
  introduction,
  thumbnailImage,
  category,
}: SanityResource) {
  const schemaData: WithContext<CreativeWork> = {
    '@context': 'https://schema.org',
    '@type': 'CreativeWork',
    url: `https://transcend.io${href}`,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://transcend.io${href}`,
    },
    name: title,
    headline: title,
    description: excerpt || blocksToText(introduction),
    publisher: schemaOrganization,
    isPartOf: {
      '@id': 'https://transcend.io/#website',
    },
    about: category.title,
    image: thumbnailImage?.url,
  };

  return <RenderSEOSchema schemaData={schemaData} />;
}
